import React from 'react'
import { imgFrame427322700 } from './assets'
import { Check } from 'lucide-react'
import { selectPersonalizedOutcomes } from '../../../../redux/userInfoSlice'
import { useSelector } from 'react-redux'

const WhatYoullLearn = () => {
  const outcomes = useSelector(selectPersonalizedOutcomes);

  return (
    <div className="content-stretch flex flex-col gap-[16px] items-start relative shrink-0 w-full">
      <p className="font-bold leading-none not-italic relative shrink-0 text-[#70aeff] text-[16px] w-full capitalize">
      After this course, you’ll be able to:
      </p>
      <div className="flex flex-col gap-[12px] items-start relative shrink-0 w-full">
        {outcomes?.map((text, index) => (
          <div key={index} className="flex gap-[8px] items-center justify-start relative shrink-0 w-full">
            <div className="relative shrink-0 size-[16px]">
              <Check className="size-full text-[#54B226]" />
            </div>
            <p className="font-normal leading-[1.4] not-italic text-[12px] text-[rgba(255,255,255,0.5)]">
              {text?.slice(3)}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default WhatYoullLearn